<template>
    <Box :title="'合同查询('+Total+'条)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
            <div class="Array">
                <div class="items" v-for="item in list" @click="$router.push({name: 'Accessory', params: {item} })">
                    <div>
                        <img src="@/assets/img/ContractIcon.jpg" />
                        <div>
                            <div>
                                <span class="ellipsis">{{item.HTMC}}</span>
                                <span class="ellipsis">¥ {{item.HTJE}}</span>
                                <img src="../../assets/img/right.png" />
                            </div>
                            <div>
                                <div>
                                    <p>合同编号：</p>
                                    <p>合同类型：</p>
                                    <p>乙方单位：</p>
                                    <p class="ellipsis">乙方联系人：</p>
                                    <p>签订时间：</p>
                                </div>
                                <div>
                                    <p class="ellipsis">{{item.HTBH}}</p>
                                    <p class="ellipsis">{{item.HTLXMC}}</p>
                                    <p class="ellipsis">{{item.HTDW}}</p>
                                    <p class="ellipsis">{{item.LXR}}</p>
                                    <p class="ellipsis">{{item.WGRQ}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span>录入时间</span>
                        <span>{{item.LRSJ}}</span>
                    </div>
                </div>
            </div>
        </LoadingFooter>
            <transition-group name="fade">
                <div class="menu" key='1' v-show="IsSee">
                    <Field title="合同编号" placeholder="请输入合同编号" @onMessage="value => search.Q = value" />

                    <Field title="合同来源" placeholder="请选择" :text='search.TBBZ' type='popup'
                    :data="['全部','申购合同','后补合同']"
                        @confirm="search.TBBZ=arguments[0]" />

                    <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StartDate = value" />
                    <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                    <div class="search" @click="serach">查询</div>
                </div>
            </transition-group>
    </Box>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'ScrapList',
        data() {
            return {
                search: {
                    Q: "",
                    TBBZ:'',
                    StartDate: null,
                    EndDate: null
                },
                loading: true,
                finished: true,
                page: 5,
                list: [],
                touchStartY:0,
                IsSee:false,
                Total:0
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        mounted(){
            this.LoadAccessory();
        },
        methods: {
            serach() {
                this.IsSee=false;
                this.page=5;
                this.LoadAccessory();
            },
            onLoad() {
                if(!this.loading && !this.finished){
                this.loading = true;
                this.page += 5;
                this.LoadAccessory();
                }
            },
            LoadAccessory() {
                this.$post('api/HT/HTTPList', {
                    PageIndex: 1,
                    PageSize: this.page,
                    Q:this.search.Q,
                    TBBZ:this.search.TBBZ=="申购合同"?'0':this.search.TBBZ=='后补合同'?'1':'',
                    StartDate: this.search.StartDate,
                    EndDate: this.search.EndDate,
                    Store: this.$UserInfo.StoreCode,
                    UserCode: this.$UserInfo.UserId,
                    Token: ''
                }).then(result => {
                    this.Total = result.Total;
                    this.list = result.HTTPList;
                    if (this.list.length < this.page) {
                        this.loading = false;
                        this.finished = true;
                    } else {
                        this.finished = false;
                        this.loading = false;

                    }
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 192px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:last-child {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div {
                                    &:last-child {
                                        p {
                                            width: 370px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }
    .Array{
     margin-top: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/page/accessoryList/accessoryList.vue